import { IModule, ModuleID } from './types'

import DevLog from './devlog/Module'
import VoidModule from './void/Module'

import { REGISTERED_MODULES } from '.'

export interface IModuleManager {
  get(moduleID: ModuleID): IModule
  config(moduleID: ModuleID, props: unknown): IModuleManager
  load(...moduleIDs: ModuleID[]): Promise<IModuleManager>
}

const moduleIDsToLoad: Set<ModuleID> = new Set()

const ModuleManager: IModuleManager = {
  get(moduleID) {
    return REGISTERED_MODULES[moduleID] || VoidModule
  },
  config(moduleID, props) {
    const module = ModuleManager.get(moduleID)
    module.config(props)
    if (!module.loaded) {
      moduleIDsToLoad.add(moduleID)
    }
    return ModuleManager
  },
  async load(...moduleIDs) {
    // await new Promise(resolve => setTimeout(resolve, 3000))
    if (moduleIDs.length) {
      for (const moduleID of moduleIDs) {
        moduleIDsToLoad.add(moduleID)
      }
    }
    if (moduleIDsToLoad.size) {
      await Promise.all(
        [...moduleIDsToLoad].map(moduleID => {
          const module = ModuleManager.get(moduleID)
          return module.loaded
            ? null
            : module.load().then(
                (): void => void moduleIDsToLoad.delete(moduleID),
                error => {
                  DevLog.error(error, `[module ${moduleID}] load:`)
                }
              )
        })
      )
    }
    return ModuleManager
  }
}

export default ModuleManager
